import React from 'react'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'

export default function DropdownButton({ dropdownOpen, setDropdownOpen, className = "mr-4" }) {

  return (
    <button className={className} onClick={() => setDropdownOpen(!dropdownOpen)}>{dropdownOpen ? <ChevronUp /> : <ChevronDown />}</button>
  )
}